import request from '@/utils/request'
import shop from "@/api/shop";
import user from "@/api/user";
import food from "@/api/food";
import order from "@/api/order";


// 公共分类（字典数据）
export const commonConfig = function (data) {
    return request({
        url: '/v1/common/config',
        method: 'post',
        data: data
    })
}

// 公共配置（字典数据）
export const commonSite = function (data) {
    return request({
        url: '/v1/common/site',
        method: 'post',
        data: data
    })
}

// 获取全部城市
export const commonArea = function (data) {
    return request({
        url: '/api/common/area',
        method: 'get',
        params: data
    })
}

// 第三方登录
export const getThird = function (data) {
    return request({
        url: '/v1/user/third',
        method: 'get',
        params: data
    })
}

// 获取JSSDK
export const getJSSDK = function (data) {
    return request({
        url: '/v1/weixin/jssdk',
        method: 'get',
        params: data
    })
}

// 获取定位
export const getLatLng = function (data) {
    return request({
        url: '/v1/user/get_location',
        method: 'post',
        data: data
    })
}

// 保存定位
export const sendLatLng = function (data) {
    return request({
        url: '/v1/user/location',
        method: 'post',
        data: data
    })
}



export default {
    commonArea,
    commonConfig,
    commonSite,
    getThird,
    getJSSDK,
    getLatLng,
    sendLatLng,
    ...shop,
    ...user,
    ...food,
    ...order
}
